// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { MutualFundsHoldingsOverlapModule } from './app.module';
bootstrapAppModule(MutualFundsHoldingsOverlapModule);
